import React from 'react'
import {
    MultiSelect as PrimeMultiSelect,
    MultiSelectProps,
    MultiSelectPanelHeaderTemplateEvent,
} from 'primereact/multiselect'
import { Checkbox } from 'primereact/checkbox'

interface CustomMultiSelectProps extends MultiSelectProps {
    selectAllLabel?: string
    testId?: string
}

export const MultiSelect: React.FC<CustomMultiSelectProps> = ({
    selectAllLabel = 'Select All',
    testId,
    filter,
    selectAll,
    showSelectAll,
    ...props
}) => {
    const panelHeaderTemplate = (templateProps: MultiSelectPanelHeaderTemplateEvent) => {
        const checkboxId = `${testId || 'multiselect'}-selectall`

        return (
            <div className="p-multiselect-header">
                <div className="flex flex-column gap-3">
                    {templateProps.filterElement}
                    {(selectAll || showSelectAll) && (
                        <div className="flex align-items-center gap-2">
                            <Checkbox
                                inputId={checkboxId}
                                checked={templateProps.checked}
                                onChange={templateProps.onChange}
                                className="mr-0"
                            />
                            <label htmlFor={checkboxId} className="cursor-pointer mb-0">
                                {selectAllLabel}
                            </label>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    return (
        <PrimeMultiSelect
            {...props}
            filter={filter}
            selectAll={selectAll}
            showSelectAll={showSelectAll}
            panelHeaderTemplate={filter || selectAll || showSelectAll ? panelHeaderTemplate : props.panelHeaderTemplate}
        />
    )
}
